/**
 * created by tian ruo jun
 自定义删除弹窗
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "antd";

export default class RmtPopconfirm extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <>
                {this.props.children}
                <Modal
                    title={
                        <div style={{
                            display:'flex',
                            marginTop:18,
                            marginLeft:10,
                            fontWeight: 500,
                            fontSize: '16px',
                            lineHeight: 1.4,
                        }}>
                        {this.props.icon}
                        {this.props.title}
                    </div>
                    }
                    mask={false}
                    closable={false}
                    visible={this.props.visible}
                    footer={this.props.footer}
                    className={'RmtPopconfirm'}
                    width={420}
                >
                    {this.props.content}
                </Modal>
                <style>
                    {
                        `
                        .RmtPopconfirm .ant-modal-header,
                        .RmtPopconfirm .ant-modal-footer
                        {
                            border:unset !important;
                            background:#fff !important;
                        }
                        .RmtPopconfirm .ant-modal-footer {
                            padding: 0px 16px 24px 16px
                        }
                        .RmtPopconfirm .ant-modal-footer button + button {
                            margin-bottom: 0 !important;
                            margin-left: 8px !important;
                        }
                        .RmtPopconfirm .ant-modal-body {
                            padding: 18px
                        }
                        `
                    }
                </style>
            </>
        )
    }

}